import React from "react";
import { NavLink } from "react-router-dom";

function EmailVerify() {
  return (
    <>
      {/* <!-- Start block --> */}
      <section className="bg-[#F8F8F8] min-h-screen body-font font-poppins">
        <div className="grid  max-w-screen-xl  lg:gap-8 xl:gap-0 lg:grid-cols-12 ">
          <div className="hidden lg:col-span-6 lg:flex w-full bg-[#00B07B] min-h-screen">
          <div className="bg-gray-100 flex-1 hidden md:flex flex-col items-center justify-center p-4">
            
            <div className="grid grid-cols-2 gap-4 w-full max-w-md">
              <img
                src="images/img4.png"
                alt="Family 1"
                className="rounded-lg object-cover w-full h-full"
              />
              <img
               src="images/img5.png"
                alt="Family 2"
                className="rounded-lg object-cover w-full h-full"
              />
              <img
               src="images/img1.png"
                alt="Family 3"
                className="rounded-lg object-cover w-full h-full"
              />
              <img
               src="images/img2.png"
                alt="Family 4"
                className="rounded-lg object-cover w-full h-full"
              />
            </div>
          </div>
          </div>

          <div className="lg:pl-20 lg:pr-6 mx-auto lg:col-span-6 lg:py-4 mt-8 md:mt-[100px]  px-2 py-10">
            <div className="flex justify-center ">
            <NavLink to="/" >
            <img src="/images/log.svg" alt="logo" className="pt-4" />
            </NavLink>
              
            </div>
            <h1 className=" text-2xl md:mt-8 mt-5 text-center text-[#0A0A0C] font-semibold leading-10 md:text-[32px] xl:text-4xl md:text-center lg:text-left">
              Check your email
             </h1>
            <p className="lg:text-[15px] md:text-[14px] text-[10px] mt-3 mb-6 text-[##414143] text-center md:text-center  lg:text-left">
              We’ve sent a verification details to your email  with a link to <br /> activate your account
            </p>
            <div className=" mt-[100px] mx-4 lg:mx-0">
              <h3 className="text-[#0A0A0C] lg:text-[20px] md:text-[16px] text-[12px] font-[600] text-center md:text-center lg:text-left">Didn’t get an email? Check your spam folder!</h3>

            </div>
          </div>
        </div>
      </section>

      {/* <!-- End block --> */}
    </>
  );
}

export default EmailVerify;
